var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_34470)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4375 20.4375C16.0974 20.4375 19.875 16.6599 19.875 12C19.875 7.34008 16.0974 3.5625 11.4375 3.5625C6.77758 3.5625 3 7.34008 3 12C3 16.6599 6.77758 20.4375 11.4375 20.4375ZM11.4375 18.75C15.1654 18.75 18.1875 15.7279 18.1875 12C18.1875 8.27206 15.1654 5.25 11.4375 5.25C7.70956 5.25 4.6875 8.27206 4.6875 12C4.6875 15.7279 7.70956 18.75 11.4375 18.75Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21L12.0403 20.9999L12.0562 21C12.0685 21 12.0808 20.9998 12.093 20.9995C17.0207 20.9497 21 16.9395 21 12C21 7.06047 17.0207 3.05034 12.093 3.00047C12.0808 3.00016 12.0685 3 12.0563 3C12.0509 3 12.0456 3.00003 12.0403 3.00009C12.0269 3.00003 12.0135 3 12 3V3.0011C11.2494 3.03063 10.65 3.64844 10.65 4.40625C10.65 5.16406 11.2494 5.78187 12 5.8114V5.8125C15.7279 5.8125 18.1875 8.27206 18.1875 12C18.1875 15.7279 15.7279 18.1875 12 18.1875V18.1886C11.2494 18.2181 10.65 18.8359 10.65 19.5938C10.65 20.3516 11.2494 20.9694 12 20.9989V21Z",
    fill: "#373737"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_34470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.2b5d16db315451aa713e58ae7f34048a.svg";
export { ForwardRef as ReactComponent };